import Axios from "axios";
import { UPDATE_NOTES } from "../_constants/actionConstants";
import { BASE_URL } from "../_constants/urlConstants";

const updateNotesActions = {
  getLatest: () => async (dispatch) => {
    dispatch({ type: UPDATE_NOTES.FETCH });
    const apiEndpoint = BASE_URL + "/api/Home/Updates";
    try {
      const res = await Axios.get(apiEndpoint);
      dispatch({ type: UPDATE_NOTES.FETCH_FULFILLED, latestUpdateNotes: res.data });
    } catch (e) {
      dispatch({ type: UPDATE_NOTES.FETCH_REJECTED });
    }
  },
};

export default updateNotesActions;
